import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';


const FormImagePreview = ({ id, name, required, accept, setFieldValue, errors, defaultImage }) => {

  const [image, setImage] = useState(defaultImage);

  useEffect(() => {
    setImage(defaultImage);
  }, [defaultImage]);

  const handleOnChangeImage = (e) => {
    const photo = e.currentTarget.files[0];
    if (photo){
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result);
        setFieldValue(name, photo);
      }
      reader.readAsDataURL(photo);
    }
  }

  const handleOnClickImage = () => {
    document.getElementById(id).click();
  }

  return (
    <div className="d-flex justify-content-center">
      <Form.File
        id={id}
        name={name} 
        accept={accept}
        required={required}
        onChange={handleOnChangeImage}
        className="d-none" />
      <figure className="placeholder-cam" onClick={handleOnClickImage}>
        <img src={image} alt="Survey Template" className="img-fluid" />
      </figure>
    </div>
  )
}

export default FormImagePreview;